// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entityId: __t.string().name("entity_id"),
  entityClass: __t.string().name("entity_class"),
  entityType: __t.string().name("entity_type"),
  appearanceColorHex: __t.option(__t.string()).name("appearance_color_hex"),
  appearanceAccessoriesJson: __t.option(__t.string()).name("appearance_accessories_json"),
  playerId: __t.option(__t.string()).name("player_id"),
  mapX: __t.i32().name("map_x"),
  mapY: __t.i32().name("map_y"),
  prevMapX: __t.option(__t.i32()).name("prev_map_x"),
  prevMapY: __t.option(__t.i32()).name("prev_map_y"),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32().name("max_hp"),
  mana: __t.option(__t.i32()),
  maxMana: __t.option(__t.i32()).name("max_mana"),
  stamina: __t.i32(),
  maxStamina: __t.i32().name("max_stamina"),
  mobInventoryValue: __t.option(__t.i32()).name("mob_inventory_value"),
  mobInventoryItemsJson: __t.option(__t.string()).name("mob_inventory_items_json"),
});
